import {
  clearSrDocumentSubtypeAction,
  deleteSrDocumentSubtype,
} from 'actions/srDocuments/srDocumentSubtypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentSubtypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentSubtypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentSubtype(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this Site Readiness Document subtype?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentSubtypeDelete
